//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapState } from "vuex";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import defaultAvatar from "@/assets/images/user.svg";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import Modals from "../../mixins/left-menu";

export default {
    name: "UserMenuModal",
    components: { AQModal },
    mixins: [Modals],
    props: {
        isExternal: { type: Boolean, default: false },
        title: { type: String, default: "Title" }
    },
    data() {
        return {
            show: true,
            platformVersion: "",
            items: [
                {
                    name: "dashboard",
                    label: this.$t("dashboard.title"),
                    icon: "dashboard",
                    to: `/${PLATFORM_BASE_PATH}/`,
                    paths: []
                },
                {
                    name: "apps",
                    label: this.$t("mainPage.sideBar.apps"),
                    icon: "view_module",
                    to: `/${PLATFORM_BASE_PATH}/applications`,
                    pathName: "apps",
                    paths: ["applications", "reports", "dataModel", "api", "documents", "userInterfaces", "diagrams", "smartContractList"]
                },
                {
                    name: "dataStoreLegacy",
                    label: this.$t("mainPage.sideBar.globalFeatures"),
                    icon: "public",
                    to: `/${PLATFORM_BASE_PATH}/dataStore/dataTablesLegacy`,
                    paths: ["globalIntegration"]
                },
                {
                    name: "administration",
                    label: this.$t("mainPage.sideBar.settings"),
                    icon: "build",
                    to: `/${PLATFORM_BASE_PATH}/administration`,
                    pathName: "administration",
                    paths: ["processInspector", "branding"]
                },
                {
                    name: "tasks",
                    label: this.$t("mainPage.sideBar.tasks"),
                    icon: "view_list",
                    to: `/${PLATFORM_BASE_PATH}/tasks`,
                    pathName: "tasks",
                    paths: []
                }
            ],
            touchStartX: 0,
            touchEndX: 0
        };
    },
    computed: {
        ...mapGetters("userProfile", ["userCookieInfo", "userProfileImage"]),
        ...mapState("components", ["isSmallScreen"]),
        ...mapGetters("apps", ["getUserSystemPermissions"]),
        ...mapGetters("admin", ["featuresByTenant"]),
        isAdmin() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("A")
                && this.getUserSystemPermissions.A.hasOwnProperty("g")
            );
        },
        isAppCreator() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("C")
                && this.getUserSystemPermissions.C.hasOwnProperty("g")
            );
        },
        isDataStoreManager() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("D")
                && this.getUserSystemPermissions.D.hasOwnProperty("g")
            );
        },
        localSmallScreen() {
            return localStorage.getItem("localIsSmallScreen") || "";
        },
        menuItems() {
            let items = [...this.items];
            if (!this.isAdmin) {
                items = items.filter((item) => item.name !== "administration");
            }
            if (!this.isDataStoreManager) {
                items = items.filter((item) => item.name !== "dataStoreLegacy");
            }
            if (this.isSmallScreen || this.localSmallScreen) {
                return items.filter(
                    (item) => !["administration", "dashboard", "dataStoreLegacy"].includes(item.name)
                );
            }
            return items;
        }
    },
    mounted() {
        if (process.env.NODE_ENV === "development") {
            this.platformVersion = "N/A on local";
        } else {
            this.getPlatformVersion().then(rsp => {
                this.platformVersion = rsp.data.aurachain.version;
            });
        }
        this.actGetUserSystemPermissions();
        window.addEventListener("touchstart", this.touchStart, true);
        window.addEventListener("touchend", this.touchEnd);
    },
    beforeDestroy() {
        window.removeEventListener("touchstart", this.touchStart);
        window.removeEventListener("touchend", this.touchEnd);
    },
    methods: {
        ...mapActions("apps", ["actGetUserSystemPermissions"]),
        ...mapActions("main", ["getPlatformVersion"]),
        isActive(item) {
            return this.$router
                && (this.$route.path.includes(item.pathName)
                    || this.$route.name.includes(item.name)
                    || item.paths.find(el => this.$route.path.includes(el)))
                ? "is-active"
                : "";
        },
        onItemClick(item) {
            this.$store.commit("apps/setCurrentApp", {});
            window.location.href = item.to;
        },
        touchStart(ev) {
            this.touchStartX = ev.changedTouches[0].screenX;
        },
        touchEnd(ev) {
            this.touchEndX = ev.changedTouches[0].screenX;
            if (this.touchStartX - this.touchEndX > 50) {
                this.show = false;
            }
        },
        onImageError(ev) {
            const param = ev;
            param.target.src = defaultAvatar;
        },
        softwareLicensesClick() {
            window.location.href = `/${PLATFORM_BASE_PATH}/softwareLicenses`;
        }
    }
};
